import { Center, Loader, SegmentedControl, Stack } from '@mantine/core';
import { useEffect, useState } from 'react';

import { useSimulationStatus } from '../../hooks';
import { SimulationContentControlModes } from './SandboxContentControlModes';

export const SandboxContentControl = () => {
  const { data: simulationStatus } = useSimulationStatus();
  const [sandboxControllerMode, setSandboxControllerMode] = useState<string>();

  useEffect(() => {
    if (simulationStatus) {
      setSandboxControllerMode('simulation');
    }

    if (simulationStatus === null) {
      setSandboxControllerMode('anon_data_upload');
    }
  }, [simulationStatus]);

  return (
    <>
      {sandboxControllerMode ? (
        <>
          <SegmentedControl
            value={sandboxControllerMode}
            onChange={setSandboxControllerMode}
            size="md"
            fullWidth
            style={{
              flexShrink: 0,
              borderRadius: 0,
            }}
            data={[
              { label: 'Upload Data', value: 'anon_data_upload' },
              { label: 'Simulation', value: 'simulation' },
              { label: 'Prefill', value: 'prefill_config' },
            ]}
          />
          <SimulationContentControlModes sandboxControllerMode={sandboxControllerMode} />
        </>
      ) : (
        <Center h="100vh">
          <Stack align="center" justify="center">
            <Loader size="lg" variant="oval" />
          </Stack>
        </Center>
      )}
    </>
  );
};
